import { FC } from 'react';
import {
  Alert,
  AlertIcon,
  AlertTitle,
  Button,
  CloseButton,
  Flex,
} from '@chakra-ui/react';

type BlockSuccessToastProps = {
  userName: string;
  handleUnblock: () => void;
  onClose: () => void;
};

export const BlockSuccessToast: FC<BlockSuccessToastProps> = ({
  userName,
  handleUnblock,
  onClose,
}) => {
  return (
    <Alert
      width="auto"
      status="success"
      variant="solid"
      borderRadius="md"
    >
      <Flex justify="space-between" width="100%">
        <Flex>
          <AlertIcon />
          <AlertTitle>Blocked {userName}</AlertTitle>
        </Flex>
        <Flex alignItems="center">
          <Button
            ml={8}
            mr={4}
            onClick={handleUnblock}
            size="sm"
            colorScheme="gray"
            variant="outline"
            _hover={{ bg: 'green.600' }}
          >
            Undo
          </Button>
          <CloseButton onClick={onClose} />
        </Flex>
      </Flex>
    </Alert>
  );
};
